// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__LFRFI","menu":"Navbar_menu__6Zx72"};